import { FileText } from 'lucide-react'
import React from 'react'

const NoDataFound = () => {
    return (
        <div className="w-full flex justify-center flex-col items-center gap-1 my-2">
            <FileText size={36} strokeWidth={0.75} className="text-gray-400" />
            <span className="text-gray-400">No Data</span>
        </div>
    )
}

export default NoDataFound
